module.exports = __webpack_public_path__ + "img/sld_mfm_spare_2_t1_b1_dark.b0d7cb23.svg";